import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Saturn = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
    
}

export default Saturn